import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, ConsultaCertificacionesResponse, ConsultarCertificacionesParams, defaultActualizarEstatus, defaultConsultaCertificaciones, defaultDetalleCertificacion, defaultNuevaCertificacion, DescargarCertificacionesParams, GuardarCertificacionParams, NuevaCertificacionParams, NuevaCertificacionResponse, DetalleCertificacionResponse } from '../../interfaces/tribunal/CertificacionInteface';

export const NuevaCertificacion = ( params: NuevaCertificacionParams ) => {

    return new Promise<NuevaCertificacionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Certificacion/NuevaCertificacion', params, token)
            .then( ({ data } : { data : NuevaCertificacionResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError) => {
                resolve( { ...defaultNuevaCertificacion, message: error.message } );
            });

        }

    });

}

export const GuardarCertificacion = ( params: GuardarCertificacionParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Certificacion/GuardarCertificacion', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DetalleCertificacion = ( id: string ) => {

    return new Promise<DetalleCertificacionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Certificacion/DetalleCertificacion/${ id }`, token)
            .then( ({ data } : { data : DetalleCertificacionResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultDetalleCertificacion });
            });

        }

    });

}

export const ActualizarEstatus = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Certificacion/ActualizarEstatus', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError) => {
                resolve( { ...defaultActualizarEstatus, message: error.message } );
            });

        }

    });

}

export const ConsultarCertificaciones = ( params: ConsultarCertificacionesParams ) => {

    return new Promise<ConsultaCertificacionesResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem( 'data' ) ?? '{}' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post( '/Api/Certificacion/ConsultarCertificaciones', params, token )
            .then( ( { data }: { data: ConsultaCertificacionesResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultConsultaCertificaciones } );
            });

        }

    });

}

export const DescargarCertificaciones = ( params: DescargarCertificacionesParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem( 'data' ) ?? '{}' );

        if ( data ) {

            const { token } = data;

            HttpClientFileToken.post( '/Api/Certificacion/DescargarCertificaciones', params, token )
            .then( ( resp: any ) => {
                resolve( resp.data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}